import _ from 'lodash'
import Vue from 'vue'
import {importComponent} from 'components/index'

let content = null

export let instances = []

export let config = {
    contentSelector: '.content',
    componentNameAttribute: 'data-component',
    componentClass: 'js-component'
}

export function initialize (mtwp) {
    _.defer(() => {
        if (mtwp.modules.pageLoader) {
            // destroy and remove components before content replacement
            mtwp.modules.pageLoader.config.hooks.beforeContentReplace.push(() => onBeforeContentReplace())
            // parse components after page loader content replacement
            mtwp.modules.pageLoader.config.hooks.afterContentReplace.push(() => parse())
        }
    })
}

export function ready (mtwp) {
    content = document.querySelector(config.contentSelector)
    parse()
}

function onBeforeContentReplace () {
    // destroy and remove content components
    _.each(_.filter(instances, component => component.scope === 'content'), component => {
        component.$destroy()
        instances = _.without(instances, component)
    })
}

function parse () {
    const componentsEls = document.querySelectorAll(`.${config.componentClass}`)
    _.each(componentsEls, el => {
        const componentName = _.upperFirst(_.camelCase(el.getAttribute(config.componentNameAttribute)))
        importComponent(componentName)
            .then(component => {
                // test if component is global or not
                let scope = 'global'
                let parent = el
                const componentObject = _.cloneDeep(component.default)

                while (parent && parent.parentNode) {
                    if (parent === content) {
                        scope = 'content'
                        parent = null
                    } else {
                        parent = parent.parentNode
                    }
                }

                // extend data object
                if (_.isPlainObject(componentObject.data)) {
                    componentObject.data = _.assign(componentObject.data, { scope })
                } else {
                    componentObject.data = { scope }
                }

                // set innerHTML as Vue template
                componentObject.template = el.innerHTML.trim()

                // create component and then mount the element
                const componentInstance = new Vue(componentObject)
                componentInstance.$mount(el)

                // remove component attribute and remove the hidden class from the component element
                componentInstance.$el.removeAttribute(config.componentNameAttribute)

                // add the instance to the set
                instances.push(componentInstance)
            })
            .catch(str => console.error(str))
    })
}


// WEBPACK FOOTER //
// ./mtwp/Theme/Js/Modules/Components.js